export default __webpack_public_path__ + "static/media/eight_.2ea96870.jpeg";